export default __webpack_public_path__ + "static/media/ETHwh.2cb05cd4.svg";